import {DateTime} from "luxon";
import {Entity} from "./entity";

export class ProjectType extends Entity<ProjectType> {
    private _key: string = `default`;

    public get key(): string {
        return this._key;
    }

    public set key(value: string) {
        this._key = value;
    }

    private _title: string = `default`;

    public get title(): string {
        return this._title;
    }

    public set title(value: string) {
        this._title = value;
    }

    private _deletedAt: DateTime | null = null;

    public get deletedAt(): DateTime | null {
        return this._deletedAt;
    }

    public set deletedAt(value: DateTime | null) {
        this._deletedAt = value;
    }

    public get isDeleted(): boolean {
        return this._deletedAt instanceof DateTime;
    }

    public get shortcut(): string {
        return this.key.split(/[\W-]+/).map(part => part[0].toUpperCase()).join(``);
    }

    private _isFixed: boolean = false;

    public get isFixed(): boolean {
        return this._isFixed;
    }

    public set isFixed(value: boolean) {
        this._isFixed = value;
        this._setOriginalValue(`isFixed`, value);
    }

    public toString(): string {
        return this.title;
    }
}